var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDisclaimer)?_c('div',{staticClass:"disclaimer",style:({
    maxWidth: _vm.maxWidth
  })},[_c('strong',[_vm._v("Disclaimer:")]),_vm._v("\n  Please search for a food as specifically as you can. For example: ‘Plain Greek Yogurt > Yogurt.’\n  We have thousands of foods to filter for you, so this will help you find what you’re looking\n  for quicker!\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }